'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const AttentionIcon = createIcon({
    displayName: 'AttentionIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M8.133 6.6v2.666m0 2.667h.007m-.93-8.739l-5.483 9.471c-.304.526-.456.788-.434 1.004.02.188.118.359.271.47.176.127.479.127 1.086.127h10.967c.607 0 .91 0 1.085-.127a.667.667 0 00.271-.47c.023-.216-.13-.478-.433-1.004l-5.484-9.47c-.303-.524-.454-.786-.652-.874a.667.667 0 00-.542 0c-.197.088-.349.35-.652.873z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default AttentionIcon
